import { useState } from "react";

const CopyField = ({ text }) => {
  const [copied, setCopied] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleCopy = () => {
    if (!text) return;

    navigator.clipboard.writeText(text);
    setCopied(true);
    setShowTooltip(true);

    setTimeout(() => {
      setCopied(false);
      setShowTooltip(false);
    }, 2000);
  };

  return (
    <span
      style={{ position: "relative", cursor: "pointer", marginLeft: "8px" }}
      onClick={handleCopy}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => !copied && setShowTooltip(false)}
    >
      {!copied ? (
        <i className="fa-solid fa-copy"></i>
      ) : (
        <i className="fa-solid fa-check" style={{ color: "green" }}></i>
      )}

      {/* Tooltip */}
      {showTooltip && (
        <span
          style={{
            position: "absolute",
            bottom: "125%",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#000",
            color: "#fff",
            padding: "4px 8px",
            fontSize: "12px",
            borderRadius: "4px",
            whiteSpace: "nowrap",
          }}
        >
          {copied ? "Copied!" : "Copy"}
        </span>
      )}
    </span>
  );
};

export default CopyField;
